import { IPostImageListItem } from '@types';
import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';

async function postAdminImageList(body: IPostImageListItem[]): Promise<AxiosResponse<FetchResult<string>>> {
  const response = await instance.post(`/admin/images`, { images: body });
  return response;
}

const usePostAdminImageList = (
  onSuccess?: (data: AxiosResponse<FetchResult<string>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { data, mutate } = useMutation({
    mutationKey: ['post', `/admin/images`],
    mutationFn: (body: IPostImageListItem[]) => postAdminImageList(body),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { data, mutate };
};

export default usePostAdminImageList;
